import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_SPOTIFY_ARTISTS_BY_IDS = gql`
  query getSpotifyArtistsByIds($ids: [String!]!) {
    getSpotifyArtistsByIds(ids: $ids) {
      isAuth
      items { id name image popularity followers genres }
    }
  }
`;

// Name and image for the ids an artist page already holds, in the same order.
const getSpotifyArtistsByIds = async (ids) => {
  if (!Array.isArray(ids) || !ids.length) return [];
  try {
    const result = await client.query({
      query: GET_SPOTIFY_ARTISTS_BY_IDS,
      variables: { ids },
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    });
    return result?.data?.getSpotifyArtistsByIds?.items || ids.map(id => ({ id }));
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getSpotifyArtistsByIds Error: ${error}`);
    return ids.map(id => ({ id }));
  }
};

export default getSpotifyArtistsByIds;
